export default __webpack_public_path__ + "static/media/domain-left-img-1.bd123e97.png";